import { useState } from 'react';

/**
 * `useDisclosure` helps handle common open, close, or toggle scenarios.
 */
export default function useDisclosure(defaultIsOpen = false) {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const onClose = () => {
    setIsOpen(false);
  };

  const onOpen = () => {
    setIsOpen(true);
  };

  const onToggle = () => {
    if (isOpen) {
      onClose();
    } else {
      onOpen();
    }
  };

  return [
    isOpen,
    {
      onOpen,
      onClose,
      onToggle,
    },
  ];
}
